<template>
  <div style="padding-top: 10px;">
    <div style="background-color: #fff; height: 35px; left: 0px; right: 0px; top: 0px; border-bottom: 1px dotted #ccc;">
      <!--<div class="date">{{page.Date}}</div>-->
      <span class="custom-dropdown custom-dropdown--white" style="float: left; font-size: 16px;">
        <select v-model="$root.activeDiaryPage" style="width: 130px;" class="custom-dropdown__select custom-dropdown__select--white">
          <option value="" disabled="disabled">בחר תאריך</option>
          <option v-for="pg in pages" :value="pg">{{pg.Date}}</option>
        </select>

      </span>
      <div style="float: right; padding-top: 5px; font-size: 16px;">

        <!--<i class="material-icons" v-if="page && page.PageKey" style="cursor: pointer;" @click="downloadPage(diaryPage, $event)" v-tooltip:bottom="{ html: 'הורדה' }">file_download</i>-->

        <span style="font-size: 12px;">מזג אויר: </span>
        <span v-if="diaryPage">
          <input v-if="canAdd()" type="text" style="text-align: center; width: 130px!important;" v-model="diaryPage.Weather" placeholder="הכנס מזג אויר" />
          <span v-else v-html="diaryPage.Weather"></span>
        </span>
        <span v-else>
          <input v-if="canAdd()" type="text" style="text-align: center; width: 130px!important;" v-model="page.Weather" placeholder="הכנס מזג אויר" />
          <span v-else v-html="page.Weather"></span>
        </span>
      </div>
    </div>

    <div class="scrollContentMobile">

        <v-subheader style="font-size: 18px;">
          <div style="width: 100%;">
            <div style="float: right; height: 25px;line-height: 45px;">הערות כלליות</div>
            <v-icon v-if="canAdd()" style="text-decoration: none; float: left; font-size: 25px; width: 25px!important; height: 25px!important;" @click="addGeneralNote" class="btnAdd">add</v-icon>
          </div>
        </v-subheader>
        <NoteEditor v-if="$root.isNewGeneralNote" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
       <div v-if="notesGeneral && notesGeneral.length > 0">
        <Note v-for="(note,index) in notesGeneral" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
      </div>
      <div v-else>
        <h5 style="color: #aaa; font-size: 14px;"> -- אין נתונים -- </h5>
      </div>
        <v-divider></v-divider>


        <v-subheader style="font-size: 18px;">
          <div style="width: 100%;">
            <div style="float: right; height: 25px;line-height: 45px;">תיאור העבודה</div>
            <v-icon v-if="canAdd()" style="text-decoration: none; float: left; font-size: 25px; width: 25px!important; height: 25px!important;" @click="addInfoNote" class="btnAdd">add</v-icon>
          </div>
        </v-subheader>
        <NoteEditor v-if="$root.isNewInfoNote" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
       <div v-if="notesInfo && notesInfo.length > 0">
        <Note v-for="(note,index) in notesInfo" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
      </div>
      <div v-else>
        <h5 style="color: #aaa; font-size: 14px;"> -- אין נתונים -- </h5>
      </div>
        <v-divider></v-divider>

        <v-subheader style="font-size: 18px;">
          <div style="width: 100%;">
            <div style="float: right; height: 25px;line-height: 45px;">הערות מנהל עבודה</div>
            <v-icon v-if="$root.isContractor && canAdd()" style="float: left; text-decoration: none; font-size: 25px; width: 25px!important; height: 25px!important;" @click="addNote" class="btnAdd">add</v-icon>
          </div>
        </v-subheader>
        <NoteEditor v-if="$root.isNewNote && $root.isContractor" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
        <div v-if="notesContractor && notesContractor.length > 0">
        <Note v-for="(note,index) in notesContractor" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
      </div>
      <div v-else>
        <h5 style="color: #aaa; font-size: 14px;"> -- אין נתונים -- </h5>
      </div>
        <v-divider></v-divider>

        <v-subheader style="font-size: 18px;">
          <div style="width: 100%;">
            <div style="float: right; height: 25px;line-height: 45px;">הערות מפקח</div>
            <v-icon v-if="$root.isInspector && canAdd()" style="float: left; text-decoration: none; font-size: 25px; width: 25px!important; height: 25px!important;" @click="addNote" class="btnAdd">add</v-icon>
          </div>
          
          
        </v-subheader>
        <NoteEditor v-if="$root.isNewNote && $root.isInspector" index="new" :date="currentDate" :time="currentTime"></NoteEditor>
        <div v-if="notesInspector && notesInspector.length > 0">
          <Note v-for="(note,index) in notesInspector" :noteData="note" :index="index" :canEdit="canEdit(note)"></Note>
        </div>
        <div v-else>
          <h5 style="color: #aaa; font-size: 14px;"> -- אין נתונים -- </h5>
        </div>
        <v-divider></v-divider>

      </div>
    </div>
</template>
<script>
  import { db } from '../firebase';
  var pagesRef = db.ref('DiaryPages');
  import Note from '../components/Note';
  import NoteEditor from '../components/NoteEditor';

  export default {
    name: 'DiaryPageMobile',
    props: ['pageKey', 'pages', 'page', 'location'],
    components: { Note, NoteEditor },
    data() {
      return {
        currentDate: '',
        currentTime: '',
        diaryPage: null,
        isNew: false,
      }
    },
    firebase: function () {
      var vm = this;
      var notesPath = 'DiaryPages/' + vm.page.PageKey + '/Notes';
      var notesRef = db.ref(notesPath);
      return {
        allNotes: notesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [DiaryPageMobile] is created ...");
      if (this.pageKey) {
        this.loadPage();
      }
    },
    ready() {
      this.$Log("Vue [DiaryPageMobile] is ready ...");
    },
    mounted() {
      this.$Log("Vue [DiaryPageMobile] is mounted ...");
    },
    updated() {
      this.$Log("Vue [DiaryPageMobile] is updated ...");
    },
    computed: {
      weatherInfo() {
        let wth = 'אין נתונים';
        if (this.$root.weather) {
          if (this.$root.weather.currently) {
            wth = this.$root.weather.currently.summary + ' ' + Math.round(this.$root.weather.currently.temperature) + '°';
          }
        }
        return wth;
      },
      pageDate() {
        if (this.$root.activeDiaryPage && this.$root.activeDiaryPage.Date) {
          return this.$root.activeDiaryPage.Date;
        } else {
          return null;
        }
      },
      //pageKey() {
      //  var vm = this;
      //  if (vm.page.PageKey == undefined) {
      //     return "";
      //  }
      //  else {
      //    return vm.page.PageKey;
      //  }
      //},
      //notesCounter() {
      //  if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
      //    return Object.keys(this.diaryPage.Notes).length;
      //  }
      //  else {
      //    return 0;
      //  }
      //},
      notes() {
        if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
          return this.diaryPage.Notes;
        }
      },
      notesGeneral() {
        var arr = [];
        if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
          var keys = Object.keys(this.diaryPage.Notes);
          for (var i = 0; i < keys.length; i++) {
            let k = keys[i];
            if (this.diaryPage.Notes[k].IsGeneral) {
              arr.push(this.diaryPage.Notes[k]);
            }
          }
        }

        return arr;
      },
      notesInfo() {
        var arr = [];
        if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
          var keys = Object.keys(this.diaryPage.Notes);
          for (var i = 0; i < keys.length; i++) {
            let k = keys[i];
            if (this.diaryPage.Notes[k].IsInfo) {
              arr.push(this.diaryPage.Notes[k]);
            }
          }
        }

        return arr;
      },
      notesInspector() {
        var arr = [];
        if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
          var keys = Object.keys(this.diaryPage.Notes);
          for (var i = 0; i < keys.length; i++) {
            let k = keys[i];
            if (!this.diaryPage.Notes[k].IsInfo && !this.diaryPage.Notes[k].IsGeneral) {
              if (this.diaryPage.Notes[k].UserType == 'מפקח') {
                arr.push(this.diaryPage.Notes[k]);
              }
            }
          }
        }

        return arr;
      },
      notesContractor() {
        var arr = [];
        if (this.diaryPage != undefined && this.diaryPage != null && this.diaryPage.Notes) {
          var keys = Object.keys(this.diaryPage.Notes);
          for (var i = 0; i < keys.length; i++) {
            let k = keys[i];
            if (!this.diaryPage.Notes[k].IsInfo && !this.diaryPage.Notes[k].IsGeneral) {
              if (this.diaryPage.Notes[k].UserType == 'מנהל עבודה') {
                arr.push(this.diaryPage.Notes[k]);
              }
            }
          }
        }

        return arr;
      },
    },
    watch: {
      //'$root.activeDiaryPage' (val) {
      //  console.log(val)
      //  this.loadPage();
      //},
      //pageKey(val) {
      //  console.log(val)
      //  this.loadPage();
      //},
      //'page.Date' (val) {
      //  console.log(val)
      //},
    },
    methods: {
      downloadPage(page, event) {
        var vm = this;
        var docWeather = "מזג אויר";
        var weatherPath = 'DiaryPages/' + page.PageKey + '/Weather';
        var weatherRef = db.ref(weatherPath);
        weatherRef.orderByKey().once('value').then(function (snapWeather) {
          let objWeather = snapWeather.val();
          vm.downloadPageWithWeather(vm, objWeather, page, event);
        });
      },
      updateNotesCounter(vm, objNotes) {
        if (objNotes) {
          var keys = Object.keys(objNotes);
          vm.counter = keys.length;
        }
        else {
          vm.counter = 0;
        }
      },
      loadPage() {
        var vm = this;
        console.log('DiaryPageMobile loadPage() ...');
        console.log('PageKey = ' + vm.PageKey);
        console.log('PageKey = ' + vm.page.PageKey);
        //alert('reload...')
        vm.$root.isNewNote = false;
        vm.$root.isNewGeneralNote = false;
        vm.$root.isNewInfoNote = false;
        vm.diaryPage = null;
        var pageKey = vm.page.PageKey;
        if (pageKey == undefined) {
          pageKey = "";
        }
        pagesRef.orderByKey().equalTo(pageKey).once('value').then(function (snapshotPage) {
          let obj = snapshotPage.val();
          if (obj) {
            let keyP = Object.keys(obj)[0];
            if (obj[keyP].Notes) {
              var notesKeys = Object.keys(obj[keyP].Notes);
              for (var k = 0; k < notesKeys.length; k++) {
                var key = notesKeys[k];
                obj[keyP].Notes[key]['.key'] = key;
              }
            }
            vm.diaryPage = obj[keyP];
            //diary.Image = proj.Images[0];
            //vm.statuses.filter(function (st) {
            //  if (st['.key'] == proj.StatusKey) {
            //    diary.Status = st;
            //    diary.Color = st.Color;
            //    vm.diaries.push(diary);
            //    return false;
            //  }
            //})
          }
          else {
          }
        });
      },
      addInfoNote() {
        var vm = this;

        vm.currentDate = vm.$moment().format('DD/MM/YYYY');
        vm.currentTime = vm.$moment().format('HH:mm');
        vm.$root.isNewGeneralNote = false;
        vm.$root.isNewInfoNote = true;

        vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
          if (!error) {
            vm.$root.weather = data;
            //alert(data.currently.time)
            //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
            //vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
            //vm.$root.isNewGeneralNote = false;
            //vm.$root.isNewInfoNote = true;
          } else {
            console.error(error)
          }
        });
      },
      addGeneralNote() {
        var vm = this;

        vm.currentDate = vm.$moment().format('DD/MM/YYYY');
        vm.currentTime = vm.$moment().format('HH:mm');
        vm.$root.isNewGeneralNote = true;
        vm.$root.isNewInfoNote = false;

        vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
          if (!error) {
            vm.$root.weather = data;
            //alert(data.currently.time)
            //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
            //vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
            //vm.$root.isNewGeneralNote = true;
            //vm.$root.isNewInfoNote = false;
          } else {
            console.error(error)
          }
        });
      },
      addNote() {
        var vm = this;

        vm.currentDate = vm.$moment().format('DD/MM/YYYY');
        vm.currentTime = vm.$moment().format('HH:mm');
        vm.$root.isNewNote = true;
        vm.$root.isNewGeneralNote = false;
        vm.$root.isNewInfoNote = false;

        vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
          if (!error) {
            vm.$root.weather = data;
            //alert(data.currently.time)
            //vm.currentDate = vm.$moment(vm.$root.weather.currently.time * 1000).format('DD/MM/YYYY');
            //vm.currentTime = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
            vm.currentDate = vm.$moment(data.currently.time * 1000).format('DD/MM/YYYY');
            vm.currentTime = vm.$moment(data.currently.time * 1000).format('HH:mm');
            vm.$root.isNewNote = true;
            vm.$root.isNewGeneralNote = false;
            vm.$root.isNewInfoNote = false;
          } else {
            console.error(error)
          }
        });
      },
      canAdd() {
        return (this.$parent.currentDate == this.page.Date && !this.$root.isObserver);
      },
      canEdit(note) {
        if (this.$parent.currentDate == this.page.Date){
          return note.UserKey == this.$root.user['.key'];
        }
        return false;
      }
    }
  }

</script>
<style scoped>
  .expansion-panel > li{
    width: 100%;
  }
  .notesList > li {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// DiaryPageMobile.vue?38f6afec